export default {
  translations: {
    fields: {
      left: 'Canhoto',
      right: 'Destro',
      masters: 'Mestrado',
      doctorate: 'Doutorado',
      mba: 'MBA',
      phd: 'Ph.D',

      cart: 'Carrinho',
      pending: 'Pendente',
      reservation_request: 'Solicitação de Reserva',
      photomatch_in_analysis: 'Photomatching / Em Análise',
      send_contract: 'Preenchimento Contrato',
      waiting_signature: 'Aguardando Assinatura',
      contract_signed: 'Contrato Assinado',
      waiting_payment: 'Aguardando Pagamento',
      waiting_payment_transport: 'Aguardando Pagamento Transporte',
      waiting_payment_verification: 'Verificação de Pagamento',
      request_for_form: 'Solicitação de SEA',
      waiting_send_request: 'SEA Enviada',
      send_scheduled: 'Envio Agendado',
      reservation_fee: 'Taxa de Reserva',
      maintenance_fee: 'Taxa de Manutenção',
      genetics: 'Genética',
      custom_import: 'Importação Personalizada',
      sended: 'Enviado',
      delivered: 'Entregue',
      maintenance: 'Manutenção',
      reserve: 'Reserva',
      after_sales: 'Pós-venda',
      canceled: 'Cancelado',
    },
  }
}
